import { render } from "./PlaceView.vue?vue&type=template&id=60914ea5"
import script from "./PlaceView.vue?vue&type=script&lang=js"
export * from "./PlaceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__